import { createAsyncThunk } from "@reduxjs/toolkit";
import { CampaignType } from "@vviinn/user-managment-client-ts";
import { ApiRequest } from "../../../api";
import { CampaignByIdRequest } from "./types";

type DeleteCampaignRequest = CampaignByIdRequest & {
  campaignType: CampaignType;
};

export const deleteCampaign = createAsyncThunk(
  "campaigns/delete",
  async ({ api, value }: ApiRequest<DeleteCampaignRequest>) => {
    const { siteId, companyId, campaignId, campaignType } = value;
    if (!companyId) return;
    await api.deleteSiteCampaignByType(
      companyId,
      siteId,
      campaignType,
      campaignId,
    );
    return campaignId;
  },
);
